<template>
  <div class="sq-wrap">
    <select v-model="queueTo" class="sq-select" :disabled="saving || loadingOptions">
      <option value="">Don't queue</option>
      <option v-for="o in options" :key="o.to_point" :value="o.to_point">Queue to {{ o.label }}</option>
    </select>
    <button class="sq-btn" :class="btnClass" :disabled="saving || disabled" @click="onClick">
      <span v-if="saving" class="spinner-border spinner-border-sm me-1"></span>
      <i v-else class="mdi me-1" :class="icon"></i>
      {{ saving ? savingLabel : (queueTo ? 'Save &amp; queue to ' + (selectedLabel || 'next') : saveLabel) }}
    </button>
  </div>
</template>

<script>
/* eslint-disable */
import { executeJson, hms } from "@/api";
export default {
  name: "SaveAndQueue",
  props: {
    fromPoint:     { type: String, required: true },
    saveLabel:     { type: String, default: "Save" },
    savingLabel:   { type: String, default: "Saving…" },
    saving:        { type: Boolean, default: false },
    disabled:      { type: Boolean, default: false },
    btnClass:      { type: String, default: "hms-btn hms-btn-primary" },
    icon:          { type: String, default: "mdi-content-save" }
  },
  emits: ["save"],
  data() {
    return { options: [], loadingOptions: true, queueTo: "" };
  },
  computed: {
    selectedLabel() {
      var o = this.options.find(x => x.to_point === this.queueTo);
      return o ? o.label : "";
    }
  },
  mounted() { this.loadOptions(); },
  methods: {
    async loadOptions() {
      try {
        var r = await executeJson({ function: "getRoutingOptions", from_point: this.fromPoint }, hms);
        if (r.data && r.data.success) this.options = (r.data.data && r.data.data.options) || [];
      } catch (e) { /* non-fatal */ }
      this.loadingOptions = false;
    },
    onClick() {
      // Parent runs its own save in response. After a successful save, the parent should call
      // ref `queueIfSelected(patientId)` so this component issues the routing ticket.
      this.$emit("save", { queueTo: this.queueTo, label: this.selectedLabel });
    },
    async queueIfSelected(patientId) {
      if (!this.queueTo || !patientId) return null;
      try {
        var r = await executeJson({ function: "queuePatientTo", patient_id: patientId, to_point: this.queueTo }, hms);
        if (r.data && r.data.success) {
          var d = r.data.data || {};
          // reset selection so the next save doesn't accidentally re-queue
          this.queueTo = "";
          return { ok: true, ticket_number: d.ticket_number, dept_name: d.dept_name };
        }
        return { ok: false, message: (r.data && r.data.message) || "Could not queue." };
      } catch (e) { return { ok: false, message: "Connection error queueing." }; }
    },
    reset() { this.queueTo = ""; }
  }
};
</script>

<style scoped>
.sq-wrap { display: inline-flex; align-items: center; gap: 8px; }
.sq-select { background: var(--hms-bg4); border: 1px solid var(--hms-input-br); border-radius: 8px; padding: 7px 12px; color: var(--hms-h); font-size: 12px; min-width: 170px; }
.sq-btn { border: none; border-radius: 8px; padding: 8px 16px; font-size: 13px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; }
.sq-btn:disabled { opacity: 0.6; cursor: not-allowed; }
</style>
